var _path, _path2, _path3, _path4, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgNhanSu = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 28.5714C0 12.7919 12.7919 0 28.5714 0H71.4286C87.2081 0 100 12.7919 100 28.5714V71.4286C100 87.2081 87.2081 100 71.4286 100H28.5714C12.7919 100 0 87.2081 0 71.4286V28.5714Z",
    fill: "url(#paint0_linear_449_859)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M66.0716 68.3743H64.0359C61.893 68.3743 59.8573 69.2047 58.3573 70.7047L53.7769 75.2315C51.6876 77.294 48.286 77.294 46.1967 75.2315L41.6163 70.7047C40.1163 69.2047 38.0538 68.3743 35.9377 68.3743H33.9288C29.4824 68.3743 25.8931 64.8119 25.8931 60.4191V31.1958C25.8931 26.8029 29.4824 23.2405 33.9288 23.2405H66.0716C70.5181 23.2405 74.1073 26.8029 74.1073 31.1958V60.4191C74.1073 64.7851 70.5181 68.3743 66.0716 68.3743Z",
    stroke: "white",
    strokeWidth: 4.01786,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M50.0004 44.6425C53.4472 44.6425 56.2415 41.8482 56.2415 38.4014C56.2415 34.9545 53.4472 32.1604 50.0004 32.1604C46.5535 32.1604 43.7593 34.9545 43.7593 38.4014C43.7593 41.8482 46.5535 44.6425 50.0004 44.6425Z",
    stroke: "white",
    strokeWidth: 4.01786,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M60.7147 59.8033C60.7147 54.9819 55.9201 51.0713 50.0004 51.0713C44.0808 51.0713 39.2861 54.9819 39.2861 59.8033",
    stroke: "white",
    strokeWidth: 4.01786,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_449_859",
    x1: 50,
    y1: 0,
    x2: 50,
    y2: 100,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB85B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF9203"
  })))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgNhanSu, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/NhanSu.bcea1ecc.svg";
export { ForwardRef as ReactComponent };